import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip, Typography } from '@mui/material';
import FileName from '../../../../../shared/ui/FileName/FileName';
import useShowError from '../../../../../shared/lib/hooks/useShowError';
import validateFile from '../../../../../shared/utils/validateFile';
import Container from './styles/Container';
import Wrapper from './styles/Wrapper';

const defaultError = 'Ошибка при обработке файла, попробуйте еще раз';
const sizeError = 'Максимально допустимый размер файла 5 MB';

function FileUploader({ id, exelFile, setExelFile, label }) {
  const fileExelFileRef = useRef(null);

  const showError = useShowError();

  const handleExelFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (!selectedFile?.name?.endsWith('.xlsx')) {
      showError('Допустимый формат только .xlsx, выберите другой файл');
      return null;
    }
    if (!validateFile(selectedFile)) {
      showError(sizeError);
      return null;
    }
    if (selectedFile) {
      setExelFile(selectedFile);
    } else {
      showError(defaultError);
      return null;
    }
    return selectedFile;
  };

  const handleCsvFileClick = () => {
    if (fileExelFileRef.current?.click) fileExelFileRef.current.click();
    else showError(defaultError);
  };

  return (
    <Container>
      <Typography variant="body1" component="div" sx={{ display: 'flex' }}>
        {label}
      </Typography>
      <Wrapper>
        <input
          ref={fileExelFileRef}
          accept=".xlsx"
          style={{ display: 'none' }}
          id={id}
          multiple
          type="file"
          onChange={handleExelFileChange}
        />
        <label htmlFor={id}>
          <Tooltip title="" placement="right" arrow>
            <Button
              onClick={handleCsvFileClick}
              variant={exelFile ? 'contained' : 'outlined'}
              component="button"
              sx={{ minWidth: '210px' }}
            >
              {exelFile ? 'Изменить файл' : 'Выбрать файл'}
            </Button>
          </Tooltip>
        </label>
        {exelFile?.name && <FileName nameFile={exelFile.name} />}
      </Wrapper>
    </Container>
  );
}

FileUploader.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  exelFile: PropTypes.shape().isRequired,
  setExelFile: PropTypes.func.isRequired,
};

export default FileUploader;
